import type { SVGProps } from "react";
// generated from ChevronDown.svg — do not edit manually
// prettier-ignore
export default function ChevronDown(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 6 9 L 12 15 L 18 9" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
